import React from "react";
import Icon from "components/Icon";
import OptionsBtn from "components/OptionsButton";
import { IChatInfo } from "stores/chats/chatInfo";
import { CHAT_CONFIG } from "utils/constants";
import { reactNativeMessenger } from "utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { updateImageSlider } from "stores/chats/chats";
import { useLocation } from "react-router-dom";

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

type HeaderProps = {
  user: {
    mobileNo: string;
    name: string;
    _id: string;
    sfId: string;
  };
  chatInfo: IChatInfo;
  redirectionOrigin?: string;
};

const Header = ({ user, chatInfo, redirectionOrigin }: HeaderProps) => {
  const sliderConfig = useSelector(
    (state: any) => state?.chatReducer?.chatSliderConfig
  );
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isMakeoUser =
    chatInfo?.botName === "makeo_buddy" && pathname?.startsWith("/user");

  const onHeaderBackClick = () => {
    if (sliderConfig.isOpen) {
      dispatch(
        updateImageSlider({
          isOpen: false
        })
      );
      const message = JSON.stringify({
        key: "SHOW_HEADER"
      });
      window.parent.postMessage(message, "*");
      return;
    }
    if (inIframe()) {
      window.parent.postMessage(
        {
          type: "headerBack",
          options: null
        },
        "*"
      );
    } else {
      reactNativeMessenger({
        data: {
          action: "CLOSE_WEBVIEW"
        }
      });
    }
  };

  // if (window.location.search.indexOf("header=false") > -1) {
  //   return null;
  // }

  const headerMarkup =
    chatInfo.botMode && chatInfo.botName ? (
      <div className="header-text">
        {CHAT_CONFIG.user[chatInfo.botName].headerText}
      </div>
    ) : (
      <img
        src={
          chatInfo.businessType.toLowerCase() === "toothsi"
            ? "https://assets.toothsi.in/apple_icon_57x57_f34cbed150.png"
            : "https://toothsicms.s3.ap-south-1.amazonaws.com/favicon_69f7aeb12b.svg"
        }
        alt={user?.name}
        className="avatar"
      />
    );

  if (redirectionOrigin) {
    return <></>;
  }

  return (
    <header
      className={`header chat__header ${
        isMakeoUser ? "chat__header--blue" : ""
      }`}
    >
      {isMakeoUser ? (
        <div className="chat__web-header">
          <button type="button" onClick={onHeaderBackClick}>
            <img
              src={"https://assets.toothsi.in/arrow_left_c6f41b3a55.svg"}
              alt="back-icon"
              width="20"
              height="22.75"
            />
          </button>
          <p className="chat__web-header--para">help</p>
        </div>
      ) : (
        <>
          <div className="chat__avatar-wrapper chat__avatar-wrapper-mobile">
            <Icon
              id="backNew"
              className="chat__header-back-new"
              onClick={onHeaderBackClick}
            />
            {headerMarkup}
          </div>
          <div className="chat__avatar-wrapper chat__avatar-wrapper-web">
            {headerMarkup}
            {/* <div className="avatar-name">{user?.name}</div> */}
          </div>
          {!chatInfo?.botName && (
            <div
              className="chat__contact-wrapper" /*onClick={openProfileSidebar}*/
            >
              {/* <h2 className="chat__contact-name"> {user?.name}</h2> */}
              {/* <p className="chat__contact-desc">
          {user.typing ? "typing..." : "online"}
        </p> */}
              <h2 className="chat__contact-name">
                {" "}
                {user.name || user.mobileNo}
              </h2>
              {user.sfId ? (
                <p className="chat__contact-desc">
                  {`UID: ${user.sfId}` || "How can I help you today ?"}
                </p>
              ) : (
                <></>
              )}
            </div>
          )}
          {/* <div className="chat__actions">
        {currentUser.type === "admin" ? (
          <OptionsBtn
          className="chat__action"
          ariaLabel="Menu"
          iconId="menu"
          iconClassName="chat__action-icon"
          options={[
            {
              text: "Bot Mode: ON",
              key: "botModeOn"
            },
            {
              text: "Bot Mode: OFF",
              key: "botModeOff"
            }
          ]}
          />
          ) : null}
        </div> */}
        </>
      )}
    </header>
  );
};

export default Header;
